import { render } from "./SteamAccountList.vue?vue&type=template&id=4d714de2"
import script from "./SteamAccountList.vue?vue&type=script&lang=js"
export * from "./SteamAccountList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Documents\\src\\steam-what-to-play-together\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__